module.exports = __webpack_public_path__ + "static/media/www.henkkatampere.fi.eab528f0.png";